
import TitleBox from '@/components/CSS/TitleBox'

export default {
    components: {
        TitleBox,
    },
    data() {
        return {
            cancelServiceMap:{CONFIDENCE_BUY:'放心购卖家权益',FAST_SELL:'极速卖卖家权益'},
            statusColors:{WAIT_PAY:'#E60F0F',IN_SERVICE:'#13BF78',REFUND:'#999999', CANCEL:'#999999'},

            loading: false,
            cancelVisible: false,
            orderId: '',
            orderDetails: {},
            centerPayDialogVisible: false, // 支付方式
            centerPayQRDialogVisible: false, // 关闭支付提示
            parInfo: {} //创建订单回调信息
        }
    },
    watch: {
        $route: {
            handler: function (route) {
                this.orderId = this.$route.query.id
                this.getDetails()
            }
        }
    },
    mounted() {
        this.orderId = this.$route.query.id
        this.getDetails()
    },
    methods: {
        // 关闭支付方式弹窗
        closePayDialogVisible(done) {
            this.centerPayQRDialogVisible = true
            if (!this.centerPayQRDialogVisible) {
                done()
            }
        },
        // 退出支付方式
        closePayDialogOkVisible() {
            this.centerPayQRDialogVisible = false
            this.centerPayDialogVisible = false
            this.$refs['qrPay'].closeDialogVisible()
        },
        // 支付成功回调
        paySuccess(payStatus, msg = '支付失败') {
            this.closePayDialogOkVisible()
            if (payStatus === 'PAY_SUCCESS') {
                this.$message.success('支付成功！')
                this.getDetails()
            } else {
                this.centerPayDialogVisible = payStatus
            }
        },
        goBackList() {
            this.$router.go(-1)
        },
        getDetails() {
            let par = {
                id: this.orderId
            }
            this.$api.serveOrderDetail(par).then((res) => {
                this.loading = true
                if (!res.success) {
                    this.loading = false
                    this.$message.error(res.info)
                    return
                }
                this.orderDetails = res.data
            })
        },
        onPay() {
            this.parInfo = {
                ...this.orderDetails,
                payName: '放心购'
            }
            this.centerPayDialogVisible = true
            this.$nextTick(() => {
                this.$refs['qrPay'].getQrCode(this.parInfo)
            })
        },
        // 取消订单
        openDialog() {
            this.cancelVisible = true
        },
        handleConfirm() {
            let par = {
                action: {
                    serviceOrderNo: this.orderDetails.serviceOrderNo
                }
            }
            if (this.orderDetails.status === 'WAIT_PAY') {
                this.$api.serveOrderCancel(par).then((res) => {
                    this.cancelVisible = false
                    if (res.success) {
                        this.$message.success('订单取消成功')
                        this.getDetails()
                    } else {
                        this.$message.error(res.info)
                    }
                })
            } else if (this.orderDetails.status === 'IN_SERVICE') {
                this.$api.serveOrderRefund(par).then((res) => {
                    this.cancelVisible = false
                    if (res.success) {
                        this.$message.success('订单取消成功')
                        this.getDetails()
                    } else {
                        this.$message.error(res.info)
                    }
                })
            }
        },
    },

}
